// extracted by mini-css-extract-plugin
module.exports = {"VotingTitle":"AssemblyVoting_VotingTitle__PrmO8","SaveButtonWrapper":"AssemblyVoting_SaveButtonWrapper__3det3","SaveButton":"AssemblyVoting_SaveButton__n4H7W"};